import { createContext, useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
    let [user, setUser] = useState(() =>
        localStorage.getItem('authTokens') ? jwtDecode(localStorage.getItem('authTokens')) : null
    );
    let [authTokens, setAuthTokens] = useState(() =>
        localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null
    );
    let [loading, setLoading] = useState(true);
    let [message, setMessage] = useState(null); // State for feedback messages

    const navigate = useNavigate();

    const loginUser = async (e) => {
        e.preventDefault();
        setMessage(null); // Clear previous messages
        const response = await fetch('https://tickets-api-q5n6.onrender.com/api/token/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username: e.target.username.value, password: e.target.password.value }),
        });

        const data = await response.json();

        if (response.ok) {
            localStorage.setItem('authTokens', JSON.stringify(data));
            setAuthTokens(data);
            setUser(jwtDecode(data.access));
            setMessage({ type: 'success', text: 'Login successful!' });
            navigate('/');
        } else {
            setMessage({ type: 'error', text: 'Invalid credentials. Please try again.' });
        }
    };

    const logoutUser = () => {
        localStorage.removeItem('authTokens');
        setAuthTokens(null);
        setUser(null);
        setMessage({ type: 'info', text: 'You have been logged out.' });
        navigate('/login');
    };

    const updateToken = async () => {
        const response = await fetch('https://tickets-api-q5n6.onrender.com/api/token/refresh/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ refresh: authTokens?.refresh }),
        });

        const data = await response.json();

        if (response.status === 200) {
            setAuthTokens(data);
            setUser(jwtDecode(data.access));
            localStorage.setItem('authTokens', JSON.stringify(data));
        } else {
            logoutUser();
        }

        if (loading) {
            setLoading(false);
        }
    };

    const contextData = {
        user: user,
        authTokens: authTokens,
        loginUser: loginUser,
        logoutUser: logoutUser,
        message: message, // Pass the message to children
    };

    useEffect(() => {
        // if (loading) {
        //     updateToken();
        // }

        const REFRESH_INTERVAL = 1000 * 60 * 60; // 1 hour
        const interval = setInterval(() => {
            if (authTokens) {
                updateToken();
            }
        }, REFRESH_INTERVAL);

        return () => clearInterval(interval);
    }, [authTokens, loading]);

    return (
        <AuthContext.Provider value={contextData}>
            {children}
        </AuthContext.Provider>
    );
};
